import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';
import { EmpresasModel } from '../../models/empresasModel';

@Injectable({
  providedIn: 'root'
})
export class EmpresasService {

  diccionarioUrl: any;
  urlEmpTerceros: string;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlEmpTerceros = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
  }

  getArticuloId(idArticulo: string){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getArticulo + idArticulo);
  }

  getAllEmpresas() {//: Observable<DatosColaboradores> {
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas);
  }

  postEmpresas(empresa : EmpresasModel) {//: Observable<DatosColaboradores> {
    return this.commom.peticionPostConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas, empresa);
  }

  updatetEmpresas(empresa : EmpresasModel) {//: Observable<DatosColaboradores> {
    return this.commom.peticionPutConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas, empresa);
  }

  deleteEmpresa(codEmpresa : string){
    return this.commom.peticionDeleteConHeader(this.urlEmpTerceros + this.diccionarioUrl.getEmpresas+"/"+codEmpresa);
  }


}
